export default {
    'name': 'folder-simple',
    'width': '24',
    'height': '24',
    'viewBox': '0 0 24 24',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M4 18.5V6.25H8.66667L11.2 8.15C11.5029 8.37719 11.8714 8.5 12.25 8.5H20V18.5H4ZM3.75 4.25C3.28587 4.25 2.84075 4.43438 2.51256 4.76256C2.18438 5.09075 2 5.53587 2 6V18.75C2 19.2141 2.18437 19.6592 2.51256 19.9874C2.84075 20.3156 3.28587 20.5 3.75 20.5H20.3333C20.7754 20.5 21.1993 20.3244 21.5118 20.0118C21.8244 19.6993 22 19.2754 22 18.8333V8.25C22 7.78587 21.8156 7.34075 21.4874 7.01256C21.1592 6.68437 20.7141 6.5 20.25 6.5H12.3333L9.8 4.6C9.49708 4.37281 9.12865 4.25 8.75 4.25H3.75Z\' fill=\'#006CFD\'/>'
}
